import type { CreateEmulatorRequest, Emulator } from '@/types/emulator'
import { GET, POST } from './helpers'

export const createEmulator = async function (devices: CreateEmulatorRequest) {
  const body = JSON.stringify(devices)

  return POST<void>('/emulator', body, {}, {}, APP_ENV.VITE_APP_EMULATORS_HOST)
}

export const getAllEmulators = async function () {
  return GET<Emulator[]>('/emulator', {}, {}, APP_ENV.VITE_APP_EMULATORS_HOST)
}
